export type ModelFamily =
  | "gpt"
  | "claude"
  | "gemini"
  | "kimi"
  | "glm"
  | "grok"
  | "deepseek"
  | "mimo"
  | "minimax"
  | "unknown";

export type ProviderTransport =
  | "openai"
  | "bedrock"
  | "azure"
  | "openrouter"
  | "google"
  | "anthropic"
  | "unknown";

export function classifyModelRef(ref: string): {
  family: ModelFamily;
  provider: ProviderTransport;
} {
  if (ref.startsWith("bedrock-openai/")) {
    return { family: "gpt", provider: "bedrock" };
  }
  if (ref.startsWith("bedrock-anthropic/")) {
    return { family: "claude", provider: "bedrock" };
  }
  if (ref.startsWith("openai/")) {
    return { family: "gpt", provider: "openai" };
  }
  if (ref.startsWith("azure/")) {
    let family: ModelFamily = "unknown";
    if (ref.includes("kimi")) {
      family = "kimi";
    } else if (ref.includes("deepseek")) {
      family = "deepseek";
    }
    return { family, provider: "azure" };
  }
  if (ref.startsWith("openrouter/")) {
    let family: ModelFamily = "unknown";
    if (ref.startsWith("openrouter/moonshotai/")) {
      family = "kimi";
    } else if (ref.includes("deepseek")) {
      family = "deepseek";
    } else if (ref.includes("grok") || ref.includes("x-ai")) {
      family = "grok";
    } else if (ref.includes("mimo")) {
      family = "mimo";
    } else if (ref.includes("minimax")) {
      family = "minimax";
    } else if (ref.includes("glm") || ref.includes("z-ai")) {
      family = "glm";
    }
    return { family, provider: "openrouter" };
  }
  if (ref.startsWith("google/")) {
    return { family: "gemini", provider: "google" };
  }
  if (ref.startsWith("anthropic/")) {
    return { family: "claude", provider: "anthropic" };
  }
  if (ref.startsWith("bedrock/")) {
    let family: ModelFamily = "claude";
    if (ref.includes("gemini")) {
      family = "gemini";
    } else if (ref.includes("claude")) {
      family = "claude";
    }
    return { family, provider: "bedrock" };
  }
  return { family: "unknown", provider: "unknown" };
}
